import Gravatar from 'react-gravatar';
import React from 'react';
import moment from 'moment';
import ua from 'ua-parser-js';
import General from '../../helpers/General.js';

class ConversationInfo extends React.Component {
    render() {
        let parser = ua(this.props.visitor.browser)

		let name = 'Unknown';
		let email = 'Unknown';
		let referrer = 'Direct';

	    if(this.props.visitor.name != '') {
	        name = this.props.visitor.name;
	    }

	    if(this.props.visitor.email != '') {
	        email = this.props.visitor.email;
	    }
	    
	    if(this.props.visitor.referrer != '') {
	        referrer = General.stripHtml(this.props.visitor.referrer);
        }

        let total = 0;

        let last = false;
		let next = false;
		let pages = this.props.pages.slice().reverse();


        return (
            <div className="info">
                <div className="details">
                    <span>Details</span>
                    <table className="table table-striped">
                        <tbody>
                            <tr>
                                <td><i className="icon fa-clock-o"></i>Current page</td>
                                <td className="name">{(this.props.visitor.online == 0 ? 'Offline':this.props.visitor.title)}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-clock-o"></i>{(this.props.visitor.online === 0 ? 'Last online':'Idle time')}</td>
                                <td className="name">{moment(this.props.visitor.last_seen).fromNow()}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-user"></i>Name</td>
                                <td className="name">{name}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-envelope"></i>E-mail</td>
                                <td className="name">{email}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-map-marker"></i>City</td>
                                <td className="name">{this.props.city}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-globe"></i>Country</td>
                                <td className="name">{this.props.country}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-user"></i>OS</td>
                                <td className="name">{parser.os.name+' '+parser.os.version}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-user"></i>Browser</td>
                                <td className="name">{parser.browser.name+' '+parser.browser.version}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-info"></i>IP</td>
                                <td className="name">{this.props.visitor.ip}</td>
                            </tr>
                            <tr>
                                <td><i className="icon fa-arrow-circle-o-right"></i>Referrer</td>
                                <td className="name">{referrer}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {this.props.cart.length > 0 ?
                <div className="cart">
                <span>Cart</span>
                <table className="table table-striped">
                    <tbody>
                    {this.props.cart.map((cart,i) => {
                        total = (parseInt(cart.price))*parseInt(cart.quantity)+total;
                        return (
                            <tr key={i}>
                                <td className="col-sm-8 padding-0 padding-bottom-5 padding-top-5">{cart.name}</td>
                                <td className="col-sm-2 padding-0 padding-bottom-5 padding-top-5">{cart.quantity}</td>
                                <td className="col-sm-2 padding-0 padding-bottom-5 padding-top-5">{(parseInt(cart.price))*parseInt(cart.quantity)}</td>
                            </tr>
                        );
                    })}

                    <tr>
                        <td className="col-sm-8 padding-0 padding-bottom-5 padding-top-5"><strong>Total</strong></td>
                        <td className="col-sm-2 padding-0 padding-bottom-5 padding-top-5"></td>
                        <td className="col-sm-2 padding-0 padding-bottom-5 padding-top-5"><strong>{total}</strong></td>
                    </tr>
                    </tbody>
                </table>
            </div>:null}

            {
                pages.length > 0 ? 
                <div className="pageviews">
				<span>Last pageviews</span>
				<table className="table table-striped">
					<tbody>
					{pages.map((page,i) => {
						if(i == 0) {
							return;
						}
						last = pages[i-1].end;
						last = moment(last);
						next = moment(page.start);
					    //
					    //page.start = moment(page.start);
						return (
							<tr key={i}>
								<td className="col-sm-12 padding-0 padding-bottom-5 padding-top-5"><i className="icon wb-globe" aria-hidden="true"></i> <a href={page.url} target="blank">{page.title}</a></td>
							</tr>
						);
					})}
					</tbody>
				</table>
			</div>:null
            }
                
            </div>
        );
    }
}

export default ConversationInfo;



// WEBPACK FOOTER //
// ./containers/chat/ConversationInfo.js